import { render, staticRenderFns } from "./LocaleStringForm.vue?vue&type=template&id=07fe383e&scoped=true&"
import script from "./LocaleStringForm.vue?vue&type=script&lang=js&"
export * from "./LocaleStringForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe383e",
  null
  
)

export default component.exports